import { Link } from 'react-router-dom';
import { useTranslation } from '../../hooks/useTranslation';
import { FirebaseProvider } from '../../contexts/FirebaseContext';
import './CorrelationsIndexPage.css';

function CorrelationsIndexContent() {
  const { translations } = useTranslation();

  // Get questions from translations (English version)
  const questionsEn = Object.keys(translations.questions.en);

  return (
    <div className="correlations-index">
      <div className="correlations-index__header">
        <h1 className="correlations-index__title">Correlation Analysis</h1>
        <p className="correlations-index__description">
          Explore how responses to one question correlate with responses to
          other questions. Select a base question below to see how its answers
          relate to all other survey questions.
        </p>
      </div>

      <ol className="correlations-index__list">
        {questionsEn.map((question, index) => {
          const questionNumber = index + 1;
          return (
            <li key={index} className="correlations-index__item">
              <Link
                to={`/correlations/${questionNumber}`}
                className="correlations-index__link"
              >
                <span className="correlations-index__number">
                  {questionNumber}.
                </span>
                <span className="correlations-index__text">{question}</span>
              </Link>
            </li>
          );
        })}
      </ol>
    </div>
  );
}

function CorrelationsIndexPage() {
  return (
    <FirebaseProvider>
      <CorrelationsIndexContent />
    </FirebaseProvider>
  );
}

export default CorrelationsIndexPage;
